<div class="px-4 pb-4">
    <ng-content></ng-content>
</div>
<div *ngIf="pageBreak" class="page-break"></div>